import { ReactNode } from 'react';

import { FormattedMessage } from '@flipster/i18n';
import { Styles, css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';

import { Picture, PictureProps } from '../../utils/Picture';
import { button } from '../../utils/button';

export const SparkRewardTrade = ({
  css: cssProp,
  ended,
  TradeCta = 'button',
  tradePicture,
}: {
  css?: Styles;
  ended: boolean;
  TradeCta?: string | ((props: { className?: string; children?: ReactNode }) => ReactNode);
  tradePicture: PictureProps;
}) => {
  return (
    <section className={css({ textAlign: 'center' }, cssProp)}>
      <h2 className={css({ textStyle: 'Display/XL', color: 'content.default.level-5', mb: [20, 60] })}>
        <FormattedMessage id='Autogen_common.r251126.s_How_to_gain_sparks' />
      </h2>
      <div className={vstack({ bg: 'background.default.level-0', rounded: 12, pt: 16 })}>
        <div
          className={css({
            mb: [12, 16],
            py: 4,
            px: 16,
            rounded: [40],
            textStyle: 'Text/L/Strong',
            color: 'content.default.level-5',
            bg: 'gray.300',
          })}
        >
          <FormattedMessage id='Autogen_common.r251126.s_Rule' />
        </div>

        <h3 className={css({ textStyle: 'Title/M', color: 'content.default.level-5', mb: 20 })}>
          Get 1 spark for <br className={css({ display: ['none', 'initial'] })} />
          every <br className={css({ display: ['initial', 'none'] })} />
          10,000 USDT trading <br className={css({ display: ['initial', 'none'] })} />
          volume!
        </h3>

        {!ended && (
          <TradeCta className={css(button.raw({ size: 'medium', display: 'inlineFlex', mode: 'light' }), { mb: 40 })}>
            <FormattedMessage id='Autogen_common.r251126.s_Trade_now' />
          </TradeCta>
        )}
        <Picture
          className={css({
            width: '100%',
            '& > img': {
              display: 'block',
              width: '100%',
              height: 'auto',
            },
          })}
          {...tradePicture}
        />
      </div>
    </section>
  );
};
